/* flex.tsx generated by @compiled/babel-plugin v0.37.1 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1n261q9c%7Bflex-wrap%3Anowrap%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1n261g80%7Bflex-wrap%3Awrap%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bah1fhb%7Bjustify-content%3Astretch%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bahitcz%7Bjustify-content%3Aspace-evenly%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bah1b1v%7Bjustify-content%3Aspace-around%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bah1yb4%7Bjustify-content%3Aspace-between%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bahh9n0%7Bjustify-content%3Aend%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bah1h6o%7Bjustify-content%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bahv2br%7Bjustify-content%3Astart%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2lx2vrvc%7Bflex-direction%3Arow%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2lx21bp4%7Bflex-direction%3Acolumn%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4cvr1fhb%7Balign-items%3Astretch%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4cvrh9n0%7Balign-items%3Aend%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4cvr1q9y%7Balign-items%3Abaseline%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4cvr1h6o%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4cvrv2br%7Balign-items%3Astart%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1p571epz%7Brow-gap%3Avar(--ds-space-1000%2C5pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1p57xncg%7Brow-gap%3Avar(--ds-space-800%2C4pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1p57oahv%7Brow-gap%3Avar(--ds-space-600%2C3pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1p571jfw%7Brow-gap%3Avar(--ds-space-500%2C40px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1p57xy5q%7Brow-gap%3Avar(--ds-space-400%2C2pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1p571ejb%7Brow-gap%3Avar(--ds-space-300%2C24px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1p57v47k%7Brow-gap%3Avar(--ds-space-250%2C20px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1p57pxbi%7Brow-gap%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1p57utpp%7Brow-gap%3Avar(--ds-space-150%2C9pt)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1p57u2gc%7Brow-gap%3Avar(--ds-space-100%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1p5712x7%7Brow-gap%3Avar(--ds-space-075%2C6px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1p571b66%7Brow-gap%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1p57v77o%7Brow-gap%3Avar(--ds-space-025%2C2px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1p57ze3t%7Brow-gap%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._gy1p1epz%7B-moz-column-gap%3Avar(--ds-space-1000%2C5pc)%3Bcolumn-gap%3Avar(--ds-space-1000%2C5pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._gy1pxncg%7B-moz-column-gap%3Avar(--ds-space-800%2C4pc)%3Bcolumn-gap%3Avar(--ds-space-800%2C4pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._gy1poahv%7B-moz-column-gap%3Avar(--ds-space-600%2C3pc)%3Bcolumn-gap%3Avar(--ds-space-600%2C3pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._gy1p1jfw%7B-moz-column-gap%3Avar(--ds-space-500%2C40px)%3Bcolumn-gap%3Avar(--ds-space-500%2C40px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._gy1pxy5q%7B-moz-column-gap%3Avar(--ds-space-400%2C2pc)%3Bcolumn-gap%3Avar(--ds-space-400%2C2pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._gy1p1ejb%7B-moz-column-gap%3Avar(--ds-space-300%2C24px)%3Bcolumn-gap%3Avar(--ds-space-300%2C24px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._gy1pv47k%7B-moz-column-gap%3Avar(--ds-space-250%2C20px)%3Bcolumn-gap%3Avar(--ds-space-250%2C20px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._gy1ppxbi%7B-moz-column-gap%3Avar(--ds-space-200%2C1pc)%3Bcolumn-gap%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._gy1putpp%7B-moz-column-gap%3Avar(--ds-space-150%2C9pt)%3Bcolumn-gap%3Avar(--ds-space-150%2C9pt)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._gy1pu2gc%7B-moz-column-gap%3Avar(--ds-space-100%2C8px)%3Bcolumn-gap%3Avar(--ds-space-100%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._gy1p12x7%7B-moz-column-gap%3Avar(--ds-space-075%2C6px)%3Bcolumn-gap%3Avar(--ds-space-075%2C6px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._gy1p1b66%7B-moz-column-gap%3Avar(--ds-space-050%2C4px)%3Bcolumn-gap%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._gy1pv77o%7B-moz-column-gap%3Avar(--ds-space-025%2C2px)%3Bcolumn-gap%3Avar(--ds-space-025%2C2px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._gy1pze3t%7B-moz-column-gap%3Avar(--ds-space-0%2C0)%3Bcolumn-gap%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._vchhusvi%7Bbox-sizing%3Aborder-box%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e0c1txw%7Bdisplay%3Aflex%7D");
import { type AriaAttributes, type ElementType, forwardRef, type ForwardRefExoticComponent, memo, type MemoExoticComponent, type ReactNode, type Ref, type RefAttributes } from 'react';
import type { AlignItems, BasePrimitiveProps, Direction, GapToken, JustifyContent, Wrap } from './types';
export type FlexProps<T extends ElementType = 'div'> = {
  /**
   * The DOM element to render as the Flex. Defaults to `div`.
   */
  as?: 'div' | 'span' | 'ul' | 'ol' | 'li' | 'dl';

  /**
   * Used to align children along the main axis.
   */
  justifyContent?: JustifyContent;

  /**
   * Used to align children along the cross axis.
   */
  alignItems?: AlignItems;

  /**
   * Represents the space between each child.
   */
  columnGap?: GapToken;

  /**
   * Represents the space between each child.
   */
  gap?: GapToken;

  /**
   * Represents the space between each child.
   */
  rowGap?: GapToken;

  /**
   * Represents the flex direction property of CSS flexbox.
   */
  direction?: Direction;

  /**
   * Represents the flex wrap property of CSS flexbox.
   */
  wrap?: Wrap;

  /**
   * Elements to be rendered inside the Flex.
   */
  children: ReactNode;

  /**
   * Forwarded ref element.
   */
  ref?: React.ComponentPropsWithRef<T>['ref'];
} & BasePrimitiveProps & AriaAttributes;
const rowGapMap = {
  'space.0': "_1p57ze3t",
  'space.025': "_1p57v77o",
  'space.050': "_1p571b66",
  'space.075': "_1p5712x7",
  'space.100': "_1p57u2gc",
  'space.150': "_1p57utpp",
  'space.200': "_1p57pxbi",
  'space.250': "_1p57v47k",
  'space.300': "_1p571ejb",
  'space.400': "_1p57xy5q",
  'space.500': "_1p571jfw",
  'space.600': "_1p57oahv",
  'space.800': "_1p57xncg",
  'space.1000': "_1p571epz"
};
const columnGapMap = {
  'space.0': "_gy1pze3t",
  'space.025': "_gy1pv77o",
  'space.050': "_gy1p1b66",
  'space.075': "_gy1p12x7",
  'space.100': "_gy1pu2gc",
  'space.150': "_gy1putpp",
  'space.200': "_gy1ppxbi",
  'space.250': "_gy1pv47k",
  'space.300': "_gy1p1ejb",
  'space.400': "_gy1pxy5q",
  'space.500': "_gy1p1jfw",
  'space.600': "_gy1poahv",
  'space.800': "_gy1pxncg",
  'space.1000': "_gy1p1epz"
};
const justifyContentMap = {
  start: "_1bahv2br",
  center: "_1bah1h6o",
  end: "_1bahh9n0",
  'space-between': "_1bah1yb4",
  'space-around': "_1bah1b1v",
  'space-evenly': "_1bahitcz",
  stretch: "_1bah1fhb"
};
const flexDirectionMap = {
  column: "_2lx21bp4",
  row: "_2lx2vrvc"
};
const flexWrapMap = {
  wrap: "_1n261g80",
  nowrap: "_1n261q9c"
};
const alignItemsMap = {
  start: "_4cvrv2br",
  center: "_4cvr1h6o",
  baseline: "_4cvr1q9y",
  end: "_4cvrh9n0",
  stretch: "_4cvr1fhb"
};
const styles = {
  root: "_1e0c1txw _vchhusvi"
};

/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */
const Flex: MemoExoticComponent<ForwardRefExoticComponent<Omit<FlexProps<ElementType>, 'ref'> & RefAttributes<any>>> = memo(forwardRef(<T extends ElementType = 'div',>({
  as: Component = 'div',
  role,
  alignItems,
  justifyContent,
  gap,
  columnGap,
  rowGap,
  children,
  testId,
  direction,
  wrap,
  xcss,
  ...ariaAttributes
}: FlexProps<T>, ref: Ref<any>) => {
  return <Component {...ariaAttributes} role={role} className={ax([styles.root, gap && columnGapMap[gap], columnGap && columnGapMap[columnGap], gap && rowGapMap[gap], rowGap && rowGapMap[rowGap], alignItems && alignItemsMap[alignItems], direction && flexDirectionMap[direction], justifyContent && justifyContentMap[justifyContent], wrap && flexWrapMap[wrap], xcss])} data-testid={testId} ref={ref}>
					{children}
				</Component>;
}));
Flex.displayName = 'Flex';
export default Flex;